function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapHydro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61.758 80.166",
    width: 45,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g-1",
    transform: "matrix(1, 0, 0, 1, 0.878877, -217.213745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25",
    transform: "translate(-71.013724,106.07418)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 24.166615,
    rx: 23.36812,
    cy: 142.80676,
    cx: 101.04585,
    id: "ellipse-1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.31139946
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fillOpacity: 1
    },
    transform: "matrix(1.201118,0,0,1.1966959,36.283235,-60.077425)",
    id: "g458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path466",
    d: "m 40.964117,175.58447 c 0,-2.61937 0.0444,-4.7625 0.09866,-4.7625 0.05426,0 0.659419,0.24805 1.344793,0.55123 0.703622,0.31124 2.10052,0.61584 3.208633,0.69965 l 1.962499,0.14842 v -7.57882 -7.57881 h 5.55625 5.55625 v 6.54844 6.54844 h 2.711979 c 1.491589,0 3.039401,0.0916 3.439583,0.20347 l 0.727605,0.20348 v 4.88975 4.88975 H 53.267242 40.964117 Z m 12.170833,-4.23546 c 1.527969,-0.30573 3.048341,-0.66695 3.378608,-0.80272 l 0.600479,-0.24685 -0.07131,-5.758 -0.07132,-5.75801 H 53.13495 49.298492 v 0.66146 c 0,0.59055 0.122259,0.67026 1.14051,0.7436 1.065384,0.0767 1.135097,0.12902 1.058333,0.79375 -0.07304,0.6325 -0.20718,0.72065 -1.206656,0.79297 -0.99379,0.0719 -1.124479,0.15646 -1.124479,0.7276 0,0.63142 0.04856,0.64625 2.116667,0.64625 h 2.116666 v 0.78262 0.78262 l -2.05052,0.0773 c -1.897653,0.0715 -2.056824,0.12166 -2.135069,0.67259 -0.0771,0.54285 0.02201,0.59531 1.124479,0.59531 1.161725,0 1.209027,0.0305 1.209027,0.77854 0,0.72678 -0.07476,0.78395 -1.124479,0.8599 -1.00136,0.0725 -1.124479,0.15378 -1.124479,0.74281 0,0.59056 0.122259,0.67027 1.14051,0.7436 1.065384,0.0767 1.135097,0.12902 1.058333,0.79375 -0.07304,0.63251 -0.20718,0.72066 -1.206656,0.79297 -0.870232,0.063 -1.124479,0.1876 -1.124479,0.55122 0,0.61125 0.192642,0.78598 0.742925,0.67384 0.246235,-0.0502 1.697856,-0.34137 3.225825,-0.64709 z",
    style: {
      fill: "#1dbdc8",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fillOpacity: 1
    },
    transform: "matrix(1.2011179,0,0,1.1966959,-113.47445,-182.86851)",
    id: "g-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    d: "m 177.18494,308.62307 c -0.37986,-0.20645 -1.18003,-1.18395 -1.77816,-2.17221 -1.55918,-2.57619 -3.28807,-4.66229 -8.3613,-10.08889 -5.14299,-5.50121 -7.091,-8.09086 -8.88857,-11.81629 -1.99051,-4.12531 -2.49415,-6.51818 -2.47809,-11.77396 0.0154,-5.02587 0.40009,-6.89426 2.21897,-10.77563 2.95125,-6.2978 8.26196,-10.75035 14.95072,-12.53482 2.78595,-0.74326 7.87851,-0.8257 10.60496,-0.17169 11.81843,2.83498 19.25365,13.92401 17.84507,26.61448 -0.82265,7.41157 -3.50157,12.21879 -11.49365,20.62492 -4.19968,4.41725 -6.84445,7.63334 -8.24074,10.02089 -1.36149,2.32803 -2.72374,2.97295 -4.37921,2.0732 z m 5.71322,-20.14542 c 5.85491,-1.5036 10.56563,-6.24065 12.19817,-12.26635 0.62016,-2.28901 0.62239,-6.43594 0.005,-8.70834 -1.64337,-6.04555 -6.45493,-10.75802 -12.5952,-12.33582 -2.3644,-0.60755 -7.13446,-0.41648 -9.45118,0.37857 -5.0802,1.74344 -9.09561,5.79976 -10.95614,11.06775 -0.7964,2.25497 -0.97263,6.63161 -0.36759,9.12898 1.64617,6.79474 7.31322,12.06351 14.16032,13.16514 1.82168,0.29308 4.93554,0.10203 7.00694,-0.42993 z",
    style: {
      fill: "#1dbdc8",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapHydro);
export default __webpack_public_path__ + "static/media/map_hydro.f9204df6291078631a0906779d3c574d.svg";
export { ForwardRef as ReactComponent };